// removed by extract-text-webpack-plugin
module.exports = {"xl":"sizeS__xl___2-Qji breakPointS-marginRight-xl","l":"sizeS__l___1zWf- breakPointS-marginRight-l","m":"sizeS__m___3Af6s breakPointS-marginRight-m","s":"sizeS__s___3ouVH breakPointS-marginRight-s","xs":"sizeS__xs___1acor breakPointS-marginRight-xs","xxs":"sizeS__xxs___a4doV breakPointS-marginRight-xxs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/sizeS.css
// module id = 14
// module chunks = 0 1 2 3 6